import React, {useState} from "react";
import {AccountSearchInterface} from "../../../../pages/customer/correspondent/list/interface/searchInterface";
import {SubmitHandler, useForm} from "react-hook-form";
import {Tooltip} from 'react-tooltip';
import {useReadContactList} from "../../../../pages/customer/contact/hooks";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {SearchContactType} from "../../../../pages/customer/contact/interface";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import PaginationSub from "../../pagination/PaginationSub";
import {useUser} from "../../../../util/userContext/UserContext";

interface AccountSearchInterfaceExtends {
    accountId: string,
    userId: number | undefined
}

/**
 * 연락처 검색 모달
 * @param props
 * @returns
 */
export const SearchContactsInner = ({
                                        confirmCallback,
                                        cancelCallback,
                                        modalDepth,
                                        args
                                    }: ModalInnerConfirmType<SearchContactType>) => {
    const {user} = useUser()

    const defaultSearchValue = {
        keywordType: "0",
        keyword: "",
        limit: 10,
        pageNo: "1",
        accountId: "",
        userId: args && args.userId ? args.userId : undefined,
    };

    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] = useState<
        AccountSearchInterface & AccountSearchInterfaceExtends
    >(defaultSearchValue);
    const [selectItem, setSelectItem] = useState<SearchContactType | null>(null);

    const {data} = useReadContactList({
        searchOption: {...searchOption, stateFlag: true},
    });

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<
        AccountSearchInterface & AccountSearchInterfaceExtends
    > = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth);
    };

    const onConfirm = () => {
        if (selectItem?.contactId) {
            confirmCallback(selectItem);
            onClose();
        } else {
            handleModal({
                isOpen: true,
                contents: "연락처를 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1,
            });
        }
    };

    const onCancel = () => {
        onClose();
        cancelCallback && cancelCallback();
    };

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <select className="form-select w-120px" {...register("keywordType")}>
                    <option value="0">전체</option>
                    <option value="1">이름</option>
                    <option value="2">회사명</option>
                    {user?.inOutFlag === 0 && <option value="3">휴대폰</option>}
                    <option value="4">회사 이메일</option>
                </select>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal" style={{tableLayout: "fixed", width: "100%"}}>
                <thead>
                <tr>
                    <th style={{width: "40px"}}></th>
                    <th style={{width: "100px"}}>이름</th>
                    <th style={{width: "100px"}}>직함</th>
                    <th style={{width: "240px"}}>회사명</th>
                    <th style={{width: "170px"}}>부서</th>
                    <th style={{width: "170px"}}>팀</th>
                    <th style={{width: "140px"}}>근무처 전화</th>
                    {user?.inOutFlag === 0 && <th style={{width: "140px"}}>휴대폰</th>}
                    <th style={{width: "auto", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>회사
                        이메일
                    </th>
                </tr>
                </thead>
                <tbody>
                {(data?.contactList ?? [])?.length === 0 ? (
                    <EmptyTableRow/>
                ) : (
                    (data?.contactList ?? [])?.map((item) => {
                        return (
                            <tr className={`clickable ${item.contactId === selectItem?.contactId ? "lightblue" : ""}`}
                                onClick={() => setSelectItem(item)}>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            onClick={() => {
                                                setSelectItem(item);
                                            }}
                                            checked={selectItem?.contactId === item?.contactId}
                                        />
                                    </div>
                                </td>
                                <td className="text-center">{item?.fullName}</td>
                                <td className="text-center">{item?.jobTitle}</td>
                                <td className="text-center">{item?.companyName}</td>
                                <td className="text-center">{item?.department}</td>
                                <td className="text-center">{item?.newTxtTeam}</td>
                                <td className="text-center">{item?.telephone1}</td>
                                {user?.inOutFlag === 0 && <td className="text-center">{item?.mobilePhone}</td>}
                                <td
                                    className="text-center"
                                    data-tooltip-id="tooltip-email"
                                    data-tooltip-content={item?.emailAddress1}
                                    style={{
                                        width: "200px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}
                                >
                                    {item?.emailAddress1}
                                </td>

                            </tr>
                        );
                    })
                )}
                </tbody>

                <Tooltip id="tooltip-email" className="custom-tooltip"/>
            </table>

            <PaginationSub
                totalCount={data?.totalCount ?? 0}
                currentPage={Number(searchOption.pageNo)}
                onChangeCallback={(i) =>
                    setSearchOption({...searchOption, pageNo: i})
                }
            />

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={onConfirm}
                >
                    선택
                </button>
            </div>
        </>
    );
};
